import React, { Fragment, ReactNode } from 'react';
import { useSiteDefinition } from 'src/core/provider/SiteProvider';

interface SiteLayoutProps {
    children: ReactNode;
}

const SiteLayout: React.FC<SiteLayoutProps> = ({ children }) => {
    const site = useSiteDefinition();
    const Shell = site.shell ?? Fragment;

    return <Shell site={site}>{children}</Shell>;
};

export default SiteLayout;
